import React from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { experience } from "./constdata";

const Experience = ({ data, onSave }) => {
  const onSelect = (value) => {
    onSave("experience", value);
  };

  return (
    <>
      <section className="expSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>
                  2. How Many Years Of Experienced Developers Do You Need?
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormControl component="fieldset" className="expRadio">
                <RadioGroup
                  aria-label="experience"
                  defaultValue="less3"
                  name="radio-buttons-group"
                  onChange={(e) => onSelect(e.target.value)}
                  value={data}
                >
                  {experience.map((e) => (
                    <FormControlLabel
                      value={e.value}
                      className="radioLabel"
                      control={<Radio />}
                      label={e.label}
                      key={e.value}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Experience;
